import { useEffect, useReducer } from 'react';

export const useClassList = (target: HTMLElement) : string[] => {
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    useEffect(() => {
        const callback = (mutations: MutationRecord[]) => {
            const includesClass = mutations.find(m => m.attributeName === 'class') !== undefined;
            if (includesClass) forceUpdate();
        };
        const observer = new MutationObserver(callback);
        observer.observe(target, { attributes: true });
        return () => observer.disconnect();
    }, []);

    return Array.from(target.classList.values());
};
